import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '@/store'
import convoUtils from './convo-utils'
import processConvos from './process-convos'
import { IConvo } from '@/model/convo'
import convoStore from '@/store/convo/convo-store';

export default async function fetchConvo(context: BareActionContext<ConvoState, RootState>, id: string)
{
  convoStore.commitSetIsLoading({isLoading: true})
  convoUtils.convoService.getById(id).then((convo: IConvo) => {
    processConvos(context, [convo])
  })

  return
}
